import { genderList } from "./constants";

const filterSex = ({ gender, t }) => {
	if (!Array.isArray(gender)) {
		gender = typeof gender === "string" ? gender.split("-") : [];
	}

	const selectedFilter = gender
		.map((value) => {
			const result = genderList.find((result) => {
				return (
					value === result.key ||
					value === result.value ||
					value === result.meta.url
				);
			});

			return result ? result.value : -1;
		})
		.filter((value) => value > -1);

	const selectedAsStringFilter = gender
		.map((value) => {
			const result = genderList.find((result) => {
				return (
					value === result.key ||
					value === result.value ||
					value === result.meta.url
				);
			});

			return result ? result.key : null;
		})
		.filter((value) => Boolean(value));

	return {
		selected: selectedFilter,
		selectedAsString: selectedAsStringFilter,
		array: genderList.map((item) => ({
			...item,
			content: t(`common:sexOptions.${item.key}`),
			text: t(`common:sexOptions.${item.key}`),
		})),
		asApiParam() {
			if (this.selected.length === 0) {
				return null;
			}

			return this.selected
				.map((value) =>
					genderList.find((result) => value === result.value)
				)
				.filter((filter) => filter != null)
				.map((result) => result.meta.value)
				.reduce((acc, shift) => acc + shift, 0);
		},
		toString() {
			if (this.selected.length === 0) {
				return null;
			}
			return this.selected
				.sort((a, b) => {
					return a - b;
				})
				.map((value) => {
					const result = genderList.find(
						(sex) => sex.value === value
					);
					return result.key;
				})
				.join("-");
		},
	};
};

export default filterSex;
